import { useMutation } from 'react-query';

import { deleteDashboardById as mutationFn } from 'api/endPoints/deleteDashboardById';

import { IDashboard } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

type IpayloadRemoveDashboard = {
    dashboardId?: string;
};
export const useMutationRemoveDashboard = () => {
    return useMutation<IDashboard, QueryError, IpayloadRemoveDashboard>((params) => mutationFn(params.dashboardId));
};
